import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "back_to_top_img",
  src: "/images/back_to_top.png",
  alt: ""
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, {
      scroll: _ctx.scroll,
      style: _normalizeStyle(_ctx.lang.cn=='t'?'font-variant-east-asian: traditional;':'')
    }, null, 8, ["scroll", "style"]),
    _createVNode(_component_Nav, {
      scroll: _ctx.scroll,
      style: _normalizeStyle(_ctx.lang.cn=='t'?'font-variant-east-asian: traditional;':'')
    }, null, 8, ["scroll", "style"]),
    _createVNode(_component_Modal, {
      style: _normalizeStyle(_ctx.lang.cn=='t'?'font-variant-east-asian: traditional;':''),
      show: _ctx.modal.show.value,
      showCancel: _ctx.modal.showCancel.value,
      image: _ctx.modal.image.value,
      model: _ctx.modal.valueHolder.value,
      onConfirm: _ctx.modal.confirm.value,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal.show.value=false))
    }, null, 8, ["style", "show", "showCancel", "image", "model", "onConfirm"]),
    _createVNode(_component_Footer, {
      id: "footer",
      style: _normalizeStyle(_ctx.lang.cn=='t'?'font-variant-east-asian: traditional;':'')
    }, null, 8, ["style"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.scroll>50)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "back_to_top",
              href: "#",
              style: _normalizeStyle(_ctx.lang.cn=='t'?'font-variant-east-asian: traditional;':'')
            }, _hoisted_2, 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}